import React from "react";
import { Offcanvas } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";

const GridField = ({ label, value, className = "term-nego" }) =>
  value !== undefined && value !== null && value !== "" ? (
    <div className={className}>
      <div className="term-label">{label}</div>
      <div className="term-value">{value}</div>
    </div>
  ) : null;

const NegotiationInfo = ({ show, handleClose, contract }) => (
  <Offcanvas show={show} onHide={handleClose} placement="end" className="contract-offcanvas">
    <Offcanvas.Header >
      <Offcanvas.Title>Contract Info</Offcanvas.Title>
      <button
        type="button"
        className="review-close-btn"
        aria-label="Close"
        onClick={handleClose}
      >
        <FaTimes />
      </button>
    </Offcanvas.Header>
    <Offcanvas.Body>
      {contract ? (
        <>
          {/* Negotiation Details */}
          <section className="contract-section">
            <h6 className="section-title">Negotiation Details</h6>
            <div className="term-row">
              <GridField label="Negotiation Name" value={contract.negotiation_name} />
              <GridField label="Contract Type" value={contract.contract_type} />
            </div>
          </section>

          {/* Contract Term Grid */}
          <section className="contract-section">
            <h6 className="section-title">CONTRACT TERM</h6>
            <div className="term-row">
              <GridField label="Effective From" value={contract.start_date && new Date(contract.start_date).toLocaleDateString('en-GB')} />
              <GridField label="Expires On" value={contract.end_date && new Date(contract.end_date).toLocaleDateString('en-GB')} />
              <GridField label="Notice Period" value={contract.termination_notice_period && `${contract.termination_notice_period} days`} />
            </div>
            <div className="term-row">
              <GridField label="Renewable" value={typeof contract.is_renewable === "boolean" ? (contract.is_renewable ? "Yes" : "No") : undefined} />
              <GridField label="Purpose of Disclosure" value={contract.purpose_of_disclosure} />
              <GridField label="Duration (Months)" value={contract.duration_in_months} />
            </div>
          </section>

          <section className="contract-section fullwidth-row">
            <GridField label="Confidential Info Definition" value={contract.confidential_info_definition} />
          </section>
          <section className="contract-section double-row">
            <GridField label="Exclusions" value={contract.exclusions} />
            <GridField label="Jurisdiction" value={contract.jurisdiction} />
          </section>
          {(contract.recipient_detail?.first_name || contract.recipient_detail?.last_name || contract.recipient_detail?.email) && (
            <section className="contract-section">
              <h6 className="section-title">Collaborator Details</h6>
              <div className="collab-row">
                <GridField
                  label="Name"
                  value={
                    [contract.recipient_detail.first_name, contract.recipient_detail.last_name]
                      .filter(Boolean)
                      .join(" ")
                  }
                />
                <GridField label="Email" value={contract.recipient_detail.email} />
              </div>
            </section>
          )}
        </>
      ) : (
        <div className="text-muted">No contract info available.</div>
      )}
    </Offcanvas.Body>
  </Offcanvas>
);

export default NegotiationInfo;
